export default class Order {
    constructor() {
        document.addEventListener("click", (event) => {
            if (event.target.closest('[data-orderid]')) {
                event.preventDefault();
                let orderDownload = event.target.closest('[data-orderid]');
                this.veritoneDownloadOrder(orderDownload.dataset.orderid, 'account');
                event.stopImmediatePropagation();
            }

            if (event.target.closest('[data-aspera]')) {
                event.preventDefault();
                let orderID = event.target.closest('[data-aspera]');
                this.veritoneAsperaDownload(orderID.dataset.aspera);
                event.stopImmediatePropagation();
            }

			if (event.target.closest('[data-downloadvideo]')) {
				event.preventDefault();
				let videoDownload = event.target.closest('[data-downloadvideo]');
				this.veritoneDownloadVideo(videoDownload.dataset.downloadvideo, 'video');
                event.stopImmediatePropagation();
			}

            if (event.target.closest('[data-downloadcollection]')) {
                event.preventDefault();
                let collectionDownload = event.target.closest('[data-downloadcollection]');
                this.veritoneDownloadVideo(collectionDownload.dataset.downloadcollection, 'collection');
                event.stopImmediatePropagation();
            }

            if (event.target.closest('#basket-checkout')) {
                event.preventDefault();
                this.veritoneCheckoutBasket();
                event.stopImmediatePropagation();
            }

            if (event.target.closest('[data-remove]')) {
                event.preventDefault();
                let itemID = event.target.closest('[data-remove]').dataset.remove;
                let projectID = event.target.closest('[data-remove]').dataset.projectid;
                this.veritoneRemoveItemFromCart(itemID, projectID);
                event.stopImmediatePropagation();
            }
        })

		document.addEventListener("change", (event) => {
			if (event.target.closest("[id*='order-attributes-']")) {
				event.preventDefault();
                let changedForm = event.target.closest("[id*='order-attributes-']");
                let changedFormID = changedForm.getAttribute('id');
                let formData = new FormData(changedForm);
				this.veritoneUpdateLineItem(changedFormID, formData);
			}

			if (event.target.closest("[name='globalIntendedUse']")) {
				event.preventDefault();
				let globalIntendedUse = event.target.closest("[name='globalIntendedUse']").value;
				let intendedUseFields = document.querySelectorAll("[name='intendedUse']");
				let orderItems = document.querySelectorAll("[id*='order-attributes-']");

				intendedUseFields.forEach((intendedUseField) => {
					intendedUseField.value = globalIntendedUse;
				});

				orderItems.forEach((orderItem) => {
					let orderItemID = orderItem.getAttribute('id');
					let formData = new FormData(orderItem);
					this.veritoneUpdateLineItem(orderItemID, formData);
				});
			}

			if (event.target.closest("[name='globalFormat']")) {
				event.preventDefault();
				let globalFormat = event.target.closest("[name='globalFormat']").value;
				let formatFields = document.querySelectorAll("[name='format']");
				let orderItems = document.querySelectorAll("[id*='order-attributes-']");

				formatFields.forEach((formatField) => {
					formatField.value = globalFormat;
				});

				orderItems.forEach((orderItem) => {
					let orderItemID = orderItem.getAttribute('id');
					let formData = new FormData(orderItem);
					this.veritoneUpdateLineItem(orderItemID, formData);
				});
			}
		});
    }

    veritoneDownloadOrder(orderID, success) {
		console.log('veritoneDownloadOrder');
        document.body.classList.remove("loaded");
        if(window.app.smoother) {
            window.app.smoother.paused(true);
        }
        let formData = new FormData();
        formData.append("orderID", orderID);

        fetch('/wp/wp-admin/admin-ajax.php?action=veritoneDownloadOrder', {
            method: 'POST',
            body: formData,
        })
        .then(response => response.json())
        .then(data => {
			console.log(data);
			if(data['error']) {
				// Alert an error if present
				let formData= new FormData();
				let modalName = 'expired-order';
				formData.append('modalName', modalName);

				fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
					method: 'POST',
					body: formData,
				})
				.then(response => response.json())
				.then(data => {
					document.querySelector('#modal__shell .modal__content').innerHTML = '';
					document.querySelector('#modal__shell .modal__content').insertAdjacentHTML('beforeend', data['modal']);
					document.querySelector('#modal__shell').classList.add('modal--large');
					document.body.classList.add('modal--open');
					document.body.classList.add("loaded");
				})
			} else {
				if(success === 'account') {
					let formData = new FormData();
					formData.append('modalName', 'download--success');

					fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
						method: 'POST',
						body: formData,
					})
					.then(response => response.json())
					.then(data => {
						this.modalContent = document.querySelector('#modal__shell .modal__content');
						this.modalContent.innerHTML = '';
						this.modalContent.insertAdjacentHTML('beforeend', data['modal']);
						document.body.classList.add('modal--open');
						document.body.classList.add("loaded");
					})
				}

				// Loop through file URLs and trigger in-browser download
				for(let i = 0; i < data.length; i++) {
					let frame = document.createElement("iframe");
					frame.className = 'downloader-frame';
					frame.src = data[i];
					frame["download"] = 1
					document.body.appendChild(frame);
				}
			}
			document.body.classList.add("loaded");
        })
    }

	veritoneDownloadVideo(ID, type) {
        document.body.classList.remove("loaded");
        if(window.app.smoother) {
            window.app.smoother.paused(true);
        }
        this.modalContent = document.querySelector('#modal__shell .modal__content');

		let formData = new FormData();
		formData.append("ID", ID);
        formData.append("downloadType", type);

		fetch('/wp/wp-admin/admin-ajax.php?action=veritoneDownloadVideo', {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
            if(data['authRequired']) {
                // If user needs to log in
                let formData= new FormData();
                let modalName = 'login';
                formData.append('modalName', modalName);

                fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
                    method: 'POST',
                    body: formData,
                })
                .then(response => response.json())
                .then(data => {
                    this.modalContent.innerHTML = '';
                    this.modalContent.insertAdjacentHTML('beforeend', data['modal']);
                    document.body.classList.add('modal--open');
                    document.body.classList.add("loaded");
                })
            } else {
                if(data['error']) {
                    // Alert an error if present
                    console.log(data['error']);
                    if(data['error'].startsWith('Price unavailable')) {
                        let formData= new FormData();
                        let modalName = 'request-access';
                        formData.append('modalName', modalName);

                        fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
                            method: 'POST',
                            body: formData,
                        })
                        .then(response => response.json())
                        .then(data => {
                            this.modalContent.innerHTML = '';
                            this.modalContent.insertAdjacentHTML('beforeend', data['modal']);
                            document.querySelector('#modal__shell').classList.add('modal--large');
                            document.body.classList.add('modal--open');
                            document.body.classList.add("loaded");
                        })
                    } else {
                        alert(data['error']);
                    }
                } else {
                    // If user is logged in
                    let formData= new FormData();
                    let modalName = 'order-summary';
                    formData.append('modalName', modalName);

                    fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
                        method: 'POST',
                        body: formData,
                    })
                    .then(response => response.json())
                    .then(data => {
                        this.modalContent.innerHTML = '';
                        this.modalContent.insertAdjacentHTML('beforeend', data['modal']);
						document.querySelector('#modal__shell').classList.add('modal--large');
                        document.body.classList.add('modal--open');
                        document.body.classList.add("loaded");
                    })
                }
            }
		})
	}

    // WIP
    veritoneAsperaDownload(orderID) {
        document.body.classList.remove("loaded");

        let formData= new FormData();
        formData.append('orderID', orderID);

        fetch('/wp/wp-admin/admin-ajax.php?action=veritoneAsperaDownload', {
            method: 'POST',
            body: formData,
        })
        .then(response => response.json())
        .then(data => {
			console.log(data);
			let formData = new FormData();

            if(Object.keys(data).length !== 0) {
				// Init the Aspera connection
				this.asperaClient = new AW4.Connect();
				this.asperaClient.addEventListener(
					AW4.Connect.EVENT.STATUS,
					(_, data) => {
						switch (data) {
							case AW4.Connect.STATUS.INITIALIZING:
								console.log('Aspera Connect is initializing...');
								return;

							case AW4.Connect.STATUS.FAILED:
								console.log('Aspera Connect failed to initialize.');
								return;

							case AW4.Connect.STATUS.OUTDATED:
								console.log('Aspera Connect is outdated.');
								return;

							case AW4.Connect.STATUS.RUNNING:
								console.log('Aspera Connect is running.');
						}
					}
				);

				this.asperaClient.initSession();

				const mappedSpecs = data.map((item) => {
					return {
						transfer_spec: JSON.parse(item.asperaSpec),
						aspera_connect_settings: {
							allow_dialogs: 'yes'
						}
					}
				});

				/**
				 * Start the download transfer
				 */
				this.asperaClient.startTransfers({
					transfer_specs: mappedSpecs
				});

				formData.append('modalName', 'download--success');
				fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
					method: 'POST',
					body: formData,
				})
				.then(response => response.json())
				.then(data => {
					this.modalContent = document.querySelector('#modal__shell .modal__content');
					this.modalContent.innerHTML = '';
					this.modalContent.insertAdjacentHTML('beforeend', data['modal']);
					document.body.classList.add('modal--open');
					document.body.classList.add("loaded");
				})
            } else {
				formData.append('modalName', 'expired-order');
				fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
					method: 'POST',
					body: formData,
				})
				.then(response => response.json())
				.then(data => {
					document.querySelector('#modal__shell .modal__content').innerHTML = '';
					document.querySelector('#modal__shell .modal__content').insertAdjacentHTML('beforeend', data['modal']);
					document.querySelector('#modal__shell').classList.add('modal--large');
					document.body.classList.add('modal--open');
					document.body.classList.add("loaded");
				})
                console.log('No asperaSpec found for the order -> has the order expired?');
            }

            document.body.classList.add("loaded");
        })
    }

	veritoneUpdateLineItem(changedFormID, formData) {
        document.body.classList.remove("loaded");
		let intendedUse = document.getElementById(changedFormID).intendedUse;
		formData.append('intendedUseName', intendedUse.options[intendedUse.selectedIndex].text);

		fetch('/wp/wp-admin/admin-ajax.php?action=veritoneUpdateLineItem', {
			method: 'POST',
			body: formData,
		})
		.then(response => response.json())
		.then(data => {
			if(data['error']) {
				alert(data['error']);
			} else {
				console.log('Cart item updated');
			}
            document.body.classList.add("loaded");
		})
	}

    veritoneCheckoutBasket() {
        document.body.classList.remove("loaded");
        fetch('/wp/wp-admin/admin-ajax.php?action=veritoneCheckoutBasket', {
            method: 'POST',
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            if(data['error']) {
                console.log('Order encountered an error');
                console.log(data);
            } else {
                console.log('Order successful');
                let formData= new FormData();
                formData.append('modalName', 'order--success');

                fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
                    method: 'POST',
                    body: formData,
                })
                .then(response => response.json())
                .then(data => {
                    this.modalContent.innerHTML = '';
                    this.modalContent.insertAdjacentHTML('beforeend', data['modal']);
                    document.body.classList.add('modal--open');
                    document.body.classList.add("loaded");
                })
                // if(data['orderID']) {
                //     this.veritoneDownloadOrder(data['orderID'], 'basket');
                // }
            }
        })
    }

    veritoneRemoveItemFromCart(itemID, projectID) {
        document.body.classList.remove("loaded");

        let formData = new FormData();
        formData.append('itemID', itemID);
        formData.append('projectID', projectID);

        fetch('/wp/wp-admin/admin-ajax.php?action=veritoneRemoveItemFromCart', {
            method: 'POST',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                if(data['error']) {
                    console.log('Removing item from cart has encountered an error');
                    console.log(data);
                    document.body.classList.add("loaded");
                } else {
                    let formData= new FormData();
                    let modalName = 'order-summary';
                    formData.append('modalName', modalName);

                    fetch('/wp/wp-admin/admin-ajax.php?action=injectModal', {
                        method: 'POST',
                        body: formData,
                    })
                    .then(response => response.json())
                    .then(data => {
                        this.modalContent.innerHTML = '';
                        this.modalContent.insertAdjacentHTML('beforeend', data['modal']);
                        document.querySelector('#modal__shell').classList.add('modal--large');
                        document.body.classList.add('modal--open');
                        document.body.classList.add("loaded");
                    })
                }
            })
    }
}